export default __webpack_public_path__ + "static/8-135dc942398e0c12122b62351a0648b1.png";